<mat-card>
    <mat-card-header>
        <mat-card-title>Workspace Owner</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="workspaceGroup" (ngSubmit)="updateWorkspaceOwner()">
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>New Owner Email</mat-label>
                <input matInput type="email" [formControl]="workspaceGroup.controls.emailControl">
                <mat-error *ngIf="workspaceGroup.controls.emailControl.invalid">{{getErrorEmail()}}</mat-error>
            </mat-form-field>
            <mat-card-actions>
                <button mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!workspaceGroup.valid" color="accent">Update</button>
                <button mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
            </mat-card-actions>
        </form>
    </mat-card-content>
</mat-card>